import React, { useState, useEffect } from 'react';
import { Grid } from '@mui/material';
import CountWidget from './count-widget.component';
import { getCounters } from '../../services/reports.service';
import { CONTENT_ALIAS } from '../../config/const.config';
import ROUTE_PATH from '../../config/routes.config';

const Counters = () => {
  const [counters, setCounters] = useState({
    videos: 0,
    subscribers: 0,
    sessions: 0,
    liveSessions: 0,
  });

  useEffect(() => {
    getCounters()
      .then((res) => {
        setCounters({
          ...counters,
          videos: res?.data?.videos || 0,
          subscribers: res?.data?.subscribers || 0,
          sessions: res?.data?.sessions || 0,
          liveSessions: res?.data?.liveSessions || 0,
        });
      })
      .catch(() => {
        // ignore
      });
  }, []);

  return (
    <Grid container spacing={3} mb={3}>
      <Grid item xs={12} sm={3} md={3}>
        <CountWidget
          title={`${CONTENT_ALIAS.VIDEO_PLURAL}`}
          total={counters.videos}
          color="success"
          icon="octicon:video-16"
          navLink={ROUTE_PATH.CONTENT_VIDEOS}
        />
      </Grid>

      <Grid item xs={12} sm={3} md={3}>
        <CountWidget
          title="Subscribers"
          total={counters.subscribers}
          color="error"
          icon="ci:users"
        />
      </Grid>

      <Grid item xs={12} sm={3} md={3}>
        <CountWidget
          title="Watched Sessions"
          total={counters.sessions}
          color="warning"
          icon="ic:outline-list-alt"
          navLink={ROUTE_PATH.REPORTS_SESSIONS}
        />
      </Grid>

      <Grid item xs={12} sm={3} md={3}>
        <CountWidget
          title="Live Sessions"
          total={counters.liveSessions}
          color="info"
          icon="fluent:live-24-filled"
          navLink={null}
        />
      </Grid>
    </Grid>
  );
};

export default Counters;
